import {fetchBody, URL_PERMISSION_GET_ROLE_LIST, URL_PERMISSION_GET_DEFAULT_LIST, URL_PERMISSION_SET_ROLE_PERMISSION} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";


export function api_getRolePermissionList ({mReqPermissionList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqPermissionList, token}), 
      url: URL_PERMISSION_GET_ROLE_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getDefaultPermissionList ({mReqPermissionList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqPermissionList, token}), 
      url: URL_PERMISSION_GET_DEFAULT_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}


export function api_setPermission ({mRespPermissionList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespPermissionList, token}), 
      url: URL_PERMISSION_SET_ROLE_PERMISSION, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}
